import React from 'react'
import { M_CheckBox, M_DrawerTableTextField } from 'src/components/M_Components'

export default function TransportationResources({ optionsTransportResources, transportResources, setTransportResources, createStructure, t, container }) {

    return (
        <div className='cardOrderService'>
            <div className='divTitleCard'>
                <div className='divAlignTitleStatus'>
                    <div className='iconTitleCard'>
                        <img src="/icons/svgsDaNet/forklift.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="OrderService"
                        />
                    </div>
                    <div className='labelTitleCard'>
                        {t("TransportResources")}
                    </div>
                </div>
            </div>
            <div className='gridInputsTransportationResources'>
                {optionsTransportResources.filter((elem) => elem.IsHiddenList !== true).map((elem1, key1) => (
                    <div key={key1}>
                        {elem1.Type === 'boolean' ? (
                            <div className='divCheckboxFormQuotes'>
                                {/* adicionar validação para o gerador e a licença especial */}
                                <M_CheckBox
                                    label={elem1.NormalizedName}
                                    onChange={(e) => createStructure(e.target.checked, elem1.Name, "Resources")}
                                    checked={Boolean(transportResources[elem1.Name] !== undefined ? transportResources[elem1.Name] : false)}
                                    disabled={elem1.Name === 'SpecialLicense' ? container?.SpecialDimensions === true ? true: false : false}
                                />
                            </div>
                        ) : elem1.Type === 'string' ? (
                            <M_DrawerTableTextField
                                key={key1}
                                tableLabel={elem1.NormalizedName}
                                label={elem1.NormalizedName}
                                required={elem1.IsRequired}
                                entity={elem1.ForeignTableName}
                                value={transportResources[elem1.ForeignTableToPassId] ? {
                                    [elem1.ForeignTableToPassId]: transportResources[elem1.ForeignTableToPassId],
                                    [elem1.ForeignKeyName]: transportResources[elem1.Name]
                                } : null}
                                filterField={elem1.ForeignKeyName}
                                labelFields={[elem1.ForeignKeyName]}
                                onSubmitValue={obj => {
                                    let updatedTransportResources = { ...transportResources }
                                    if (obj) {
                                        updatedTransportResources[elem1.Name] = obj[elem1.ForeignKeyName]
                                        updatedTransportResources[elem1.ForeignTableToPassId] = obj[elem1.ForeignTableToPassId]
                                    } else {
                                        updatedTransportResources[elem1.Name] = null
                                        updatedTransportResources[elem1.ForeignTableToPassId] = null
                                    }
                                    setTransportResources(updatedTransportResources)
                                }}
                                disabled={elem1.disable}
                                valueField={elem1.ForeignTableToPassId}
                            />
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    )
}